/**
 * @description メッセージ取得メソッド
 * @param code メッセージコード
 * @param customeWords 入れ替わる単語配列
 * @returns メッセージ
 */
export const getMessage = (code: string, customeWords?: string[]): string => {
  const messageItem: Message | undefined = messages.find(
    (item: Message): boolean => item.code === code.toUpperCase()
  )

  if (!messageItem) {
    console.warn('メッセージの取得に失敗しました。')
    return ''
  }

  let message: string = messageItem.message

  customeWords?.forEach((word: string, index: number): void => {
    message = message.replace(`{${index}}`, word)
  })

  return message
}

interface GetDubbleMessagesParameters {
  underlineMessageCode?: string
  underlineMessageCustomeWords?: string[]
  pageMessageCode?: string
  pageMessageCustomeWords?: string[]
}

/**
 * @description 二箇所メッセージ取得メソッド
 * @param parameters メッセージ取得用引数
 * @returns メッセージ配列
 */
export const getDubbleMessages = ({
  underlineMessageCode,
  underlineMessageCustomeWords,
  pageMessageCode,
  pageMessageCustomeWords,
}: GetDubbleMessagesParameters): [string, string] => {
  const underlineMessage = underlineMessageCode
    ? getMessage(underlineMessageCode, underlineMessageCustomeWords)
    : ''

  let pageMessage: string

  if (!pageMessageCode && !pageMessageCustomeWords?.length) {
    // ページメッセージが要らない場合
    pageMessage = ''
  } else if (!pageMessageCode) {
    // フォームエラーの場合
    pageMessage = getMessage('EF0033', pageMessageCustomeWords)
  } else {
    pageMessage = getMessage(pageMessageCode, pageMessageCustomeWords)
  }

  return [underlineMessage, pageMessage]
}

export interface Message {
  code: string
  message: string
}

export const messages: Message[] = [
  { code: 'EB0001', message: '企業IDを入力してください。' },
  { code: 'EB0002', message: '内部エラーが発生しました。' },
  { code: 'EB0003', message: 'タイムアウトが発生しました。' },
  { code: 'EB0010', message: '入力した自社商品コードは既に登録されています。' },
  { code: 'EB0015', message: '指定されたフォルダを参照できません。' },
  { code: 'EB0016', message: '利用者情報にて法人番号を登録してください。' },
  { code: 'EF0001', message: '入力してください。' },
  { code: 'EF0002', message: '指定された{0}は存在しません。' },
  { code: 'EF0003', message: '1件以上、登録してください。' },
  { code: 'EF0004', message: '{0} 以下のファイルにしてください。' },
  { code: 'EF0005', message: '入力した内容は保存されませんが、よろしいですか？' },
  { code: 'EF0006', message: '保存しますか？' },
  { code: 'EF0007', message: '{0}形式のみアップロード可能です。' },
  { code: 'EF0008', message: '{0}の{1}に失敗しました。' },
  { code: 'EF0009', message: '{0}を選択してください。' },
  { code: 'EF0010', message: '半角英数字・記号で入力してください。' },
  { code: 'EF0011', message: '半角英数字で入力してください。' },
  { code: 'EF0012', message: '半角英字で入力してください。' },
  { code: 'EF0013', message: '{0}しますか？' },
  { code: 'EF0014', message: '{0}ますか？' },
  { code: 'EF0015', message: '形式が正しくありません。' },
  { code: 'EF0017', message: '入力された法人番号は存在しません。' },
  { code: 'EF0018', message: '法人番号は13桁で指定してください' },
  { code: 'EF0021', message: '{0}文字以内で入力してください。' },
  { code: 'EF0033', message: '{0}をご確認の上、再度{1}をおこなってください。' },
  { code: 'EF0034', message: '選択してください。' },
  { code: 'EF0035', message: '自社の法人番号は登録できません。' },
  {
    code: 'EF0036',
    message: '利用者が完全に削除されますが、　よろしいですか？',
  },
  { code: 'EF0037', message: 'ファイル名は入力文字数を0～{0}以内にしてください。' },
  {
    code: 'EF0038',
    message: '  送信するドキュメントを追加してください。',
  },
  {
    code: 'EF0039',
    message: '  送信先を選択してください。',
  },
  {
    code: 'EF0040',
    message: 'ログをご確認ください',
  },
  {
    code: 'EF9901',
    message: '登録に失敗しました。時間をおいてから、再度操作してください。',
  },

  {
    code: 'EF9904',
    message: '取得に失敗しました。時間をおいてから、再度操作してください。',
  },

  {
    code: 'EF9905',
    message: '通信が失敗しました。画面を再度読み込みしてください。 ',
  },
  {
    code: 'EF002007',
    message:
      '姓は（漢字、ひらがな、カタカナ、アルファベット）16文字まで入力してください。',
  },
  {
    code: 'EF002009',
    message:
      '名は（漢字、ひらがな、カタカナ、アルファベット）16文字まで入力してください。',
  },

  { code: 'EF06002', message: '同階層に同じ名前のフォルダが既に存在します。' },

  {
    code: 'EF007002',
    message: '送信先マスタが作成されています。',
  },

  {
    code: 'EF007003',
    message: '該当送信先マスタを選択する権限がありません。',
  },

  {
    code: 'EF007004',
    message: '取り込み処理が完了しました。',
  },

  {
    code: 'EF007005',
    message: '取り込み処理が完了しました。（エラーログをご確認ください。）',
  },

  {
    code: 'EF007006',
    message: '取り込み処理に失敗しました。',
  },

  {
    code: 'EF007007',
    message: '取り込み処理が失敗しました。（csv ファイルのフォーマットが不正です。）',
  },

  {
    code: 'EF007008',
    message: '全商品の紐付は解除できません。',
  },

  {
    code: 'EF015001',
    message: '自社商品コードの紐付または新規登録をおこなってください。',
  },

  { code: 'EF015002', message: '既に受領されています。' },
  { code: 'EF015003', message: '既に受領拒否されています。' },
  { code: 'EF018001', message: 'このドキュメント種別は既に登録されています。' },

  { code: 'IF0001', message: '正常に更新されました。' },
  { code: 'IF0002', message: 'ファイルが正常に出力されました。' },
  { code: 'IF0003', message: '{0}を{1}しました。' },
  { code: 'IF0004', message: '{0}を{1}できません。' },
  { code: 'IF0005', message: '{0}しました。' },
  { code: 'IF0006', message: '同じファイル名が存在します。' },
  { code: 'IF0007', message: '未受領の送信履歴がある一部商品を削除できませんでした。\n送信取消を実施後に再度実行してください。' },
  { code: 'IF0008', message: 'リクエストが完了しました。\n受信フォルダを確認してください。' },

  {
    code: 'EF012002',
    message: '取り込み処理が失敗しました。（csvファイルのフォーマットが不正です。）',
  },
  {
    code: 'EF012003',
    message: '取り込み処理が失敗しました。（エラーログをご確認ください。）',
  },
  {
    code: 'EF012005',
    message: '取り込み処理が失敗しました。（最大2000件です。）',
  },
  {
    code: 'EF012006',
    message: '「移行元フォルダ」と「移行先フォルダ」は異なるフォルダを選択してください。',
  },
  {
    code: 'EF012007',
    message: '受信フォルダの情報を引き継ぎますか？',
  },
  {
    code: 'EF012008',
    message: 'ゲストアカウントを削除して\nよろしいですか？',
  },
  {
    code: 'EF012009',
    message: '未受領の取引があります。\nゲストアカウントを削除して\nよろしいですか？',
  },
  {
    code: 'EF012010',
    message: '対象データがありません。',
  },
  {
    code: 'EF012011',
    message: '改版送信対象を1件以上選択してください。',
  },
  {
    code: 'EF012012',
    message: '{0}は入力文字数を{1}～{2}以内にしてください。',
  },
  {
    code: 'EF012013',
    message:
      '受領済みドキュメントの紐付が削除されたため、送信元の最新の商品情報を表示しています。',
  },
  {
    code: 'EF012014',
    message:
      'リマインド送信対象は50件以内で選択してください。（選択数：{0}）',
  },
  {
    code: 'EF012015',
    message:
      'ドキュメント送信対象は50件以内で選択してください。（選択数：{0}）',
  },
]
